<template>

	<div class="inbox-sidebar">

		<router-link to="/inbox/new-message" class="btn green compose-btn btn-block">

			<div class="visual">
				<i class="fa fa-edit" aria-hidden="true"></i>
				<span v-translate>Nova</span>
			</div>

		</router-link>

		<ul class="inbox-nav">

			<li>

				<router-link to="/inbox">
					<span v-translate>Recebidas</span>
				</router-link>

			</li>

			<li>

				<router-link to="/inbox/send-message">
					<span v-translate>Enviadas</span>
				</router-link>

			</li>

		</ul>

	</div>

</template>

<script>

	import InboxSidebarMenu from './';
	export default InboxSidebarMenu;

</script>

<style lang="scss" scoped>

	.inbox-sidebar {
		background: #fff;
		border: 0;
	}

	.inbox {

		.inbox-nav {

			> li {

				> span {
					text-decoration: none !important;
					display: block;
					padding: 8px 16px;
				}

			}

			.router-link-active {

				&.router-link-exact-active {
					border-left: 4px solid #ed6b75;
				}

			}

		}

	}

</style>



// WEBPACK FOOTER //
// sidebar-menu.vue?b17c7f1c